import axios from '../axios';
// 销售订单列表
export const getSalOrderPage = data => {
  return axios({
    url: '/api/sys/sal/getSalOrderPage',
    method: 'post',
    data
  })
};
// 本月销售订单列表（用于销售称重表|今日记录）
export const getSalOrderMonthPage = data => {
  return axios({
    url: '/api/sys/sal/getSalOrderMonthPage',
    method: 'post',
    data
  })
};
// 【和顺德】本月销售订单合计
export const getSalOrderMonthTotal = data => {
  return axios({
    url: '/api/sys/sal/getSalOrderMonthTotal',
    method: 'post',
    data
  })
};
// 销售订单列表删除
export const deleteSalOrders = data => {
  return axios({
    url: '/api/sys/sal/deleteSalOrders',
    method: 'post',
    data
  })
};
// 销售订单列表作废
export const invalidOrder = data => {
  return axios({
    url: '/api/sys/sal/invalidOrder',
    method: 'post',
    data
  })
};
// 销售订单列表关闭
export const closeOrder = data => {
  return axios({
    url: '/api/sys/sal/closeOrder',
    method: 'post',
    data
  })
};
// 销售订单列表预付款（审核）
export const auditSal = data => {
  return axios({
    url: '/api/sys/sal/auditSal',
    method: 'post',
    data
  })
};
// 二次审批 结算
export const settleSalOrder = data => {
  return axios({
    url: '/api/sys/sal/settleSalOrder',
    method: 'post',
    data
  })
};
// 【和顺德】二次审批 结算（单个）
export const settleSalOrderHsd = data => {
  return axios({
    url: '/api/sys/sal/settleSalOrderHsd',
    method: 'post',
    data
  })
};
// 销售订单列表保存
export const saveSalOrder = data => {
  if (!data.billId) {//保存
    return axios({
      url: '/api/sys/sal/saveSalOrder',
      method: 'post',
      data
    })
  } else {//修改
    return axios({
      url: '/api/sys/sal/updateSalOrder',
      method: 'post',
      data
    })
  }
};
// 销售订单明细列表
export const getSalOrderEntryPage = data => {
  return axios({
    url: '/api/sys/sal/getSalOrderEntryPage',
    method: 'post',
    data
  })
};
// 销售订单明细列表一次过磅
export const firstWeigh = data => {
  return axios({
    url: '/api/sys/sal/firstWeigh',
    method: 'post',
    data
  })
};
// 销售订单明细列表二次过磅
export const secondWeigh = data => {
  return axios({
    url: '/api/sys/sal/secondWeigh',
    method: 'post',
    data
  })
};
// 销售订单明细列表修改
export const updateSalOrderEntry = data => {
  return axios({
    url: '/api/sys/sal/updateSalOrderEntry',
    method: 'post',
    data
  })
};

// 销售出库单列表
export const getStkOutSalePage = data => {
  if (!data.billId) {
    return axios({
      url: '/api/sys/stk/getStkOutSalePage',
      method: 'post',
      data
    })
  } else {
    return axios({
      url: '/api/sys/stk/updateStkOutSale',
      method: 'post',
      data
    })
  }
};
// 销售出库单列表保存
export const saveStkOutSale = data => {
  if (!data.billId) {
    return axios({
      url: '/api/sys/stk/saveStkOutSale',
      method: 'post',
      data
    })
  }else{
    return axios({
      url: '/api/sys/stk/updateStkOutSale',
      method: 'post',
      data
    })
  }
};
// 销售出库单列表修改
export const updateStkOutSale = data => {
  return axios({
    url: '/api/sys/stk/updateStkOutSale',
    method: 'post',
    data
  })
};
// 销售出库单列表删除
export const deleteStkOutSales = data => {
  return axios({
    url: '/api/sys/stk/deleteStkOutSales',
    method: 'post',
    data
  })
};
// 销售出库单列表作废
export const invalidOutSale = data => {
  return axios({
    url: '/api/sys/stk/invalidOutSale',
    method: 'post',
    data
  })
};
// 销售出库单列表关闭
export const closeOutSale = data => {
  return axios({
    url: '/api/sys/stk/closeOutSale',
    method: 'post',
    data
  })
};
// 销售出库单列表审核
export const auditOutSale = data => {
  return axios({
    url: '/api/sys/stk/auditOutSale',
    method: 'post',
    data
  })
};
// 销售出库单列表反审核
export const unAuditOutSale = data => {
  return axios({
    url: '/api/sys/stk/unAuditOutSale',
    method: 'post',
    data
  })
};
// 销售出库单明细列表
export const getStkOutSaleEntryPage = data => {
  return axios({
    url: '/api/sys/stk/getStkOutSaleEntryPage',
    method: 'post',
    data
  })
};
// 销售出库单明细列表删除
export const deleteStkOutSaleEntrys = data => {
  return axios({
    url: '/api/sys/stk/deleteStkOutSaleEntrys',
    method: 'post',
    data
  })
};

// 销售出库称重
export const getStkOutSaleCarWeighList = data => {
  return axios({
    url: '/api/sys/stk/getStkOutSaleCarWeighList',
    method: 'post',
    data
  })
};

// 今日记录作废，能作废无出库单的订单
export const invalidOrderRecordOfTheDay = data => {
  return axios({
    url: '/api/sys/sal/invalidOrderRecordOfTheDay',
    method: 'post',
    data
  })
};

// SalEchartsReport
// 销售统计
export const getMaterialSpecSaleList = data => {
  return axios({
    url: '/api/sys/analyse/getMaterialSpecSaleList',
    method: 'post',
    data
  })
};
// 销售称重明细
export const getMaterialSpecWeighList = data => {
  return axios({
    url: '/api/sys/analyse/getMaterialSpecWeighList',
    method: 'post',
    data
  })
};
// 新老客户数量
export const getPartnerStatistical = data => {
  return axios({
    url: '/api/sys/analyse/getPartnerStatistical',
    method: 'post',
    data
  })
};
// 客户数量明细(周月自定义统计)
export const getPartnerCountByDate = data => {
  return axios({
    url: '/api/sys/analyse/getPartnerCountByDate',
    method: 'post',
    data
  })
};
// 新老客户充值
export const getNewOldPartnerRecharge = data => {
  return axios({
    url: '/api/sys/analyse/getNewOldPartnerRecharge',
    method: 'post',
    data
  })
};
// 新客户充值明细
export const getNewPartnerRecharge = data => {
  return axios({
    url: '/api/sys/analyse/getNewPartnerRecharge',
    method: 'post',
    data
  })
};
// 老客户充值明细
export const getOldPartnerRecharge = data => {
  return axios({
    url: '/api/sys/analyse/getOldPartnerRecharge',
    method: 'post',
    data
  })
};
// 客户充值
export const getPartnerRechargeByDate = data => {
  return axios({
    url: '/api/sys/analyse/getPartnerRechargeByDate',
    method: 'post',
    data
  })
};
// 库存
export const getMaterialStockList = data => {
  return axios({
    url: '/api/sys/analyse/getMaterialStockList',
    method: 'post',
    data
  })
};
// 采购统计
export const getMaterialSpecPurchaseList = data => {
  return axios({
    url: '/api/sys/analyse/getMaterialSpecPurchaseList',
    method: 'post',
    data
  })
};
// 采购称重明细
export const getMaterialSpecPurchaseWeighList = data => {
  return axios({
    url: '/api/sys/analyse/getMaterialSpecPurchaseWeighList',
    method: 'post',
    data
  })
};
// 销售榜
export const getPartnerSaleTopX = data => {
  return axios({
    url: '/api/sys/analyse/getPartnerSaleTopX',
    method: 'post',
    data
  })
};
// 充值榜
export const getPartnerRechargeTopX = data => {
  return axios({
    url: '/api/sys/analyse/getPartnerRechargeTopX',
    method: 'post',
    data
  })
};
// 查询过磅信息
export const listWeigh = data => {
  return axios({
    url: '/api/sys/pur/listWeigh',
    method: 'post',
    data
  })
};
// 【和顺德】车牌号模糊查询
export const getSalOrderCarList = data => {
  return axios({
    url: '/api/sys/sal/getSalOrderCarList',
    method: 'post',
    data
  })
};
// [和顺德]销售订单汇总表导出
export const getSalOrderSumExport = data => {
  return axios({
    url: '/api/sys/sal/getSalOrderSumExport',
    method: 'post',
    data
  })
};
// [和顺德]销售订单汇总表
export const getSalOrderSumPage = data => {
  return axios({
    url: '/api/sys/sal/getSalOrderSumPage',
    method: 'post',
    data
  })
};
// pda发货
export const pdaStockName = data => {
  return axios({
    url: '/api/sys/sal/pdaStockName',
    method: 'post',
    data
  })
};
// 一次重改仓库
export const updateSalOrderOfStockBySettle = data => {
  return axios({
    url: '/api/sys/sal/updateSalOrderOfStockBySettle',
    method: 'post',
    data
  })
};
export const getSalOrderQuantityStatisticsTablePage = data => {
  return axios({
    url: '/api/sys/sal/getSalOrderQuantityStatisticsTablePage',
    method: 'post',
    data
  })
};
export const getSalOrderQuantityStatisticsTablePageExport = data => {
  return axios({
    url: '/api/sys/sal/getSalOrderQuantityStatisticsTablePageExport',
    method: 'post',
    data
  })
};
//修改已出库销售订单的客户（今日记录界面）
export const updateSalOrderOfPartnerBySettle = data => {
  return axios({
    url: '/api/sys/sal/updateSalOrderOfPartnerBySettle',
    method: 'post',
    data
  })
};


// WEBPACK FOOTER //
// ./src/api/moudules/Sales.js